import { css } from "styled-components";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { defaultCardStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsDefaultCard";

defaultCardStyles.titleText = mergeToNew(defaultCardStyles.titleText, {
    variant: "h3",
    as: "h2",
    css: css`
        margin-bottom: 20px !important;
    `,
});
